/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserByUserNameResponse {
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  userName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  externalId?: string | null;
  isBlocked?: boolean;
  statusId?: number | null;
  typeId?: number | null;
}
